<template>
  <div class="space-y-4 w-ful max-w-4xl">
    <h2 class="font-semibold uppercase text-gray-600">
      Add Rider
    </h2>
    <form @submit.prevent="update" class="space-y-4">
      <div class="flex -mx-2">
        <div class="w-1/2">
          <label class="block px-2">
            <span class="text-gray-700">First Name</span>
            <input
              v-model="rider.firstName"
              class="form-input mt-1 block w-full"
              placeholder="Jane"
            />
          </label>
        </div>
        <div class="w-1/2">
          <label class="block px-2">
            <span class="text-gray-700">Last Name</span>
            <input
              v-model="rider.lastName"
              class="form-input mt-1 block w-full"
              placeholder="Doe"
            />
          </label>
        </div>
      </div>
      <label class="block">
        <span class="text-gray-700">Email</span>
        <input
          v-model="rider.email"
          class="form-input mt-1 block w-full"
          type="email"
          placeholder="johndoe@gmail.com"
        />
      </label>
      <label class="block">
        <span class="text-gray-700">Contact Number</span>
        <input
          v-model="rider.phoneNumber"
          class="form-input mt-1 block w-full"
          type="tel"
          placeholder="+251 912345678"
        />
      </label>
      <label class="block">
        <span class="text-gray-700">Profile Picture</span>
        <input class="form-input mt-1 block w-full" type="file" />
      </label>
      <button
        class="px-4 py-2 bg-blue-500 text-white font-semibold rounded hover:bg-blue-700"
      >
        Update Rider
      </button>
    </form>
  </div>
</template>

<script>
export default {
  data() {
    return {
      rider: {},
    };
  },
  created() {
    this.getRider();
  },
  computed: {
    id() {
      return this.$route.params.id;
    },
  },
  methods: {
    getRider() {
      this.$http
        .get(`users/${this.id}`)
        .then(response => (this.rider = response.data))
        .catch(err => console.log(err));
    },
    update() {
      this.$http
        .patch(`users/${this.id}`, { ...this.rider })
        .then(() => {
          window.flash({
            type: "success",
            body: "Rider information was updated successfully!",
          });
          this.$router.push("/riders");
        })
        .catch(err => console.log(err));
    },
  },
};
</script>
